import { createFileRoute, Navigate } from '@tanstack/react-router'
import { reportEditSearchSchema } from '@/schemas'
import { ReportEdit } from '@/pages/ReportEdit'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'

export const Route = createFileRoute('/_layout/reporting/$reportId/edit')({
    component: () => <RouteComponent />,
    validateSearch: reportEditSearchSchema,
})

const RouteComponent: React.FC = () => {
    const { reportId } = Route.useParams()
    return (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>
            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <ReportEdit reportId={reportId} />
            </RoleRestrictedContent>
        </>
    )
}
